import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-timeEntriesInput-control-label-view, [app-timeEntriesInput-control-label-view]',
  templateUrl: './timeEntriesInput-control-label-view.component.html',
  styleUrls: ['./timeEntriesInput-control-label-view.component.scss']
})
export class TimeEntriesInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
